var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6053 6.51327V3.68142L23.5987 2.25693C24.149 2.12614 24.4814 1.56538 24.332 1.01987L24.3069 0.928159C24.1649 0.40989 23.6388 0.096457 23.1154 0.218419L16.1678 1.83755C15.7151 1.94305 15.3948 2.3466 15.3948 2.81145V6.51327H8.16669C7.6144 6.51327 7.16669 6.96099 7.16669 7.51327V11.115H25.8334V7.51327C25.8334 6.96099 25.3856 6.51327 24.8334 6.51327H17.6053Z",
    fill: "#FF7010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25269 12.8848L9.79479 30.1591C9.94216 31.2211 10.9001 31.9998 11.9685 31.9998H20.9211C22.0264 31.9998 22.9474 31.2211 23.0948 30.1591L25.6369 12.8848H7.25269Z",
    fill: "#FF7010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/Drink.2c3a16dce3743953361affea535bfd44.svg";
export { ForwardRef as ReactComponent };